import { Collapse, Typography } from '@material-ui/core'
import WarningIcon from '@material-ui/icons/Warning'
import WatchLaterIcon from '@material-ui/icons/WatchLater'
import React, { useEffect, useState } from 'react'

import { getTranslate, lang } from '../../../../localization'
import { parseExpiryTime } from './expiryTime'
import { useStyles } from './styles/index.styles'

interface ExpireTimeCounterProps {
  expiryTime: string
  setIsTimeExpired: React.Dispatch<React.SetStateAction<boolean>>
}

const ExpireTimeCounter: React.FC<ExpireTimeCounterProps> = ({
  expiryTime,
  setIsTimeExpired
}) => {
  const classes = useStyles()
  const [timeLeftInSeconds, setTimeLeftInSeconds] = useState<number | null>(
    null
  )
  const [warning, setwarning] = useState(false)

  useEffect(() => {
    if (!expiryTime.trim()) {
      setTimeLeftInSeconds(null)
      setIsTimeExpired(false)
      setwarning(false)
      return
    }

    const targetTime = parseExpiryTime(expiryTime)
    if (targetTime === null) {
      console.error('Booking expiry timestamp is malformed')
      setTimeLeftInSeconds(null)
      setIsTimeExpired(false)
      setwarning(false)
      return
    }

    const updateTimer = () => {
      const now = Date.now()
      const diffInSeconds = Math.floor((targetTime - now) / 1000)
      setTimeLeftInSeconds(Math.max(0, diffInSeconds))

      if (diffInSeconds < 60 && diffInSeconds > 0) {
        setwarning(true)
      }
      if (diffInSeconds <= 0) {
        setIsTimeExpired(true)
        setwarning(false)
      } else {
        setIsTimeExpired(false)
      }
    }

    updateTimer()
    const interval = setInterval(updateTimer, 1000)
    return () => clearInterval(interval)
  }, [expiryTime, setIsTimeExpired])

  const formatTime = (totalSeconds: number | null) => {
    if (totalSeconds === null) return '—'

    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    const paddedMinutes = String(minutes).padStart(2, '0')
    const paddedSeconds = String(seconds).padStart(2, '0')

    return hours > 0
      ? `${hours}′ : ${paddedMinutes}′ : ${paddedSeconds}″`
      : seconds > 0
      ? `${minutes}′ : ${paddedSeconds}″`
      : minutes == 0
      ? `${getTranslate('Expired')}`
      : `${minutes}′ : ${paddedSeconds}″`
  }

  return (
    <div>
      <div className={classes.container}>
        <Typography variant="h5" className={classes.verticalAlign}>
          <WatchLaterIcon color="primary" className={classes.icon} />
          {getTranslate('Expire Time')}
        </Typography>
        <Typography
          variant="h5"
          className={classes.timeText}
          style={{ direction: lang == 'fa' ? 'ltr' : 'ltr' }}>
          {formatTime(timeLeftInSeconds)}
        </Typography>
      </div>
      <Collapse in={warning}>
        <div className={classes.warning}>
          <Typography
            variant="subtitle1"
            className={classes.verticalAlignWarning}>
            <WarningIcon className={classes.iconWarning} />
            {getTranslate('Finish this step earlier please')}
          </Typography>
          <Typography variant="h6" className={classes.warningText}>
            {getTranslate(
              'The Timer will run out in one minute, and once it ends, you will be taken back to step 1'
            )}
          </Typography>
        </div>
      </Collapse>
    </div>
  )
}

export default ExpireTimeCounter
